var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25 50a25 25 0 010-50 25 25 0 010 50zm10.2-12.3h.4c1-.3 2-1 2-2.2v-21c-.2-1-1-2-2.3-2.2h-21c-1 .3-2 1.2-2 2.4v20.9c.2 1 1 2 2.3 2h20.5zM15 22.7V34c0 .5.5 1 1 1h18c.5 0 1-.5 1-1V22.6h-2.5c.4 1 .5 2 .3 3.2 0 1-.5 2-1 3-.6 1-1.4 2-2.4 2.5-2.4 1.7-5.7 2-8.3.4-1.2-.8-2.2-2-3-3.2-1-2-1.2-4-.5-6.2H15zm10-3c-2.8 0-5 2.4-5.2 5.2 0 2.8 2.3 5 5 5 3 .2 5.3-2 5.3-5 .2-2.8-2-5.2-5-5.2zm7.7-1H34c.5 0 1-.4 1-1v-2.3c0-.6-.5-1-1-1h-2.5a1 1 0 00-1 1V18c.2.6.6.8 1 .8h1.2z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social--instagram-9760aecf108974cde8755dc95c16ff30.svg";
export { SvgIconSocialInstagram as Component };